import sourceLocale from 'antd/lib/locale/default'

import { merge } from 'lodash'
import zh_CN from './zh_CN'

const defaultLocale = merge({}, sourceLocale, zh_CN)

export default defaultLocale
